import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { ContentProvider } from "@/lib/content";
import StarField from "@/components/StarField";
import RocketIntro from "@/components/RocketIntro";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import ExplorePlanet from "@/pages/ExplorePlanet";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Dashboard from "@/pages/Dashboard";
import Verify from "@/pages/Verify";
import Track from "@/pages/Track";
import Frames from "@/pages/Frames";
import FrameDetail from "@/pages/FrameDetail";
import FrameConfirmation from "@/pages/FrameConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import Legal from "@/pages/Legal";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import ContactUs from "@/pages/ContactUs";

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render (synchronous check to avoid race)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/explore/:planet" element={<ExplorePlanet />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/confirmation/:registrationNumber" element={<Confirmation />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/track" element={<Track />} />
      <Route path="/frames" element={<Frames />} />
      <Route path="/frames/confirmation/:orderNumber" element={<FrameConfirmation />} />
      <Route path="/frames/:frameId" element={<FrameDetail />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/refund" element={<RefundPolicy />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <div className="App" data-testid="app-root">
          <RocketIntro />
          <StarField />
          <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <AppRouter />
            <Footer />
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </div>
      </ContentProvider>
    </AuthProvider>
  );
}
